import React from 'react';
import { Box, Heading, Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import PackageOption from './PackageOption.Base';
import { PackageOptionProps } from './types';

const BestAvailableRates = (
  props: Omit<PackageOptionProps, 'title' | 'children'>,
) => {
  return (
    <PackageOption
      {...props}
      title="Best Available Rates"
      isBestAvailableRate={true}
    >
      <Box>
        <Heading.h6
          color={themeGet('components.packageOption.travelAnytime.color')}
          mb={'4px'}
          fontSize={['18px', null, '20px']}
          lineHeight={['27px', null, '30px']}
        >
          Travel anytime
        </Heading.h6>
        <Text
          fontSize={['16px', null, '18px']}
          lineHeight={['24px', null, '27px']}
        >
          Pick your own flights + stay package and save
        </Text>
      </Box>
    </PackageOption>
  );
};

export default BestAvailableRates;
